// @ts-nocheck
import * as React from "react";

const ArrowUpward: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M5.23 10.64a1 1 0 0 0 1.41.13L11 7.14V19a1 1 0 1 0 2 0V7.14l4.36 3.63a1.001 1.001 0 0 0 1.28-1.54l-6-5-.15-.09-.13-.07a1 1 0 0 0-.72 0l-.13.07-.15.09-6 5a1 1 0 0 0-.13 1.41Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ArrowUpward);
